import { Component, input, output } from '@angular/core';

// TODO: Implement mobile header or remove this file
@Component({
  selector: 'dmcom-header-mobile',
  imports: [],
  template: ` <div class="header"></div> `,
  styles: [``],
})
export class HeaderMobileResponsive {
  public readonly isSidebarOpened = input.required<boolean>();
  public readonly toggleSidebar = output<void>();

  onToggleSidebar() {
    this.toggleSidebar.emit();
  }
}
